module.exports = __webpack_public_path__ + "img/Seat Too Shallow.bfe5ee7f.png";